module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAIJJREFUGBljZACC/2/fyjD8/NkFZDqA+EBwgIGdvYxRWPgJI1jyx4+LQEEhsBSCeMfAwaHPAtUpxPDsGQPDyZMQaXNzBgYpKSGQHBNQxAEsCpL89g2CYQqBciAFeAFIwQGwCpCxXFwQDGJDwAGCjmQCeQXkWgZGxuVA/ByKl4PEQHIAas8uzhrNY0YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs/report-icon-acne-1@2x.png
// module id = GKYX
// module chunks = 1